import { RegionInfoDto, CreateRegionDto } from '@sr/dto';
import { FormikErrors } from 'formik';
import { VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';
import { fromCoordinates, validateCoordinatesFields } from '../coordinates-fields';

export interface FormValues {
  name: string;
  countryId: number | '';
  federalCode: string | '';
  slug: string;
  latitude: string;
  longitude: string;
}


export const fromRegion = (region: RegionInfoDto): FormValues => {
  return {
    name: region.name,
    countryId: region.country.id,
    federalCode: region.federalCode,
    slug: region.slug ?? '',
    latitude: fromCoordinates(region.latitude),
    longitude: fromCoordinates(region.longitude),
  };
};

export const toRegion = (formData: FormValues): CreateRegionDto => {
  return {
    name: formData.name,
    countryId: Number(formData.countryId)
  };
};


export const initialValues: FormValues = {
  name: '',
  countryId: '',
  federalCode: '',
  slug: '',
  latitude: '',
  longitude: '',
};

export const validate = (values: FormValues) => {
  const errors: FormikErrors<FormValues> = {};

  if (!values.name) errors.name = VALIDATION_REQUIRED_FIELD;

  if (!values.countryId) errors.countryId = VALIDATION_REQUIRED_FIELD;

  Object.assign(errors, validateCoordinatesFields(values));

  return errors;
};
